<template>
    <div id="GeNumberObj">
        <h2><span id="gefahrnummerSpan">{{ gefahrnummer.gefahrnummer }}</span> <span id="gefahrbezeichnungSpan">{{ gefahrnummer.bezeichnung }}</span></h2>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    name: "GeNumberObj",
    components: {},
    props: {
        gefahrnummer: Object,
    },
    data() {
        return {};
    },
    methods: {
        
    },
    created() {
        
    },
};
</script>

<style lang="scss">
#GeNumberObj {
    font-size: x-large;
    display: flex;
    justify-content: space-between;
    margin-left: 10%;
    margin-right: 10%;
    background-color: white;
    border: solid black 0.2rem;
    padding: 0.3rem;
    padding-left: 3rem;

    @media (max-width: 768px) {
        margin-left: 5%;
        margin-right: 5%;
        padding-left: 0rem;
        flex-direction: column;
        align-items: center;

        h2{
            margin-bottom: 0px;
            font-size: large;
            width: 100%;
            display: flex;
            justify-content:space-between;
            min-height: 3rem;
            margin: 0;
            span{
                display: inline-block;
                vertical-align: middle;
            }
        }

        #gefahrnummerSpan{
            text-align: left;
            padding-left: 1rem;
        }

        #gefahrbezeichnungSpan{
            padding-left: 2rem;
            width: 100%;
            text-align: left;
        }

        .field {
            width: auto !important;
        }
    }
}
</style>
